/* eslint-disable no-undef */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './logging';
import Vue from 'vue';
import './unique_id_helper';
import './component_hooks';
import './notifications';
import App from './App';
import router from './router';
import i18n from './languages';
import store from './store';
import vmodal from 'vue-js-modal';
import { axiosInstance } from './api';
import VueAxios from 'vue-axios';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import vTooltip from 'v-tooltip';
import vMediaQuery from 'v-media-query';
import {GET_LANGUAGE, SET_LANGUAGE} from './store/modules/locale';
import { SCREEN_SM } from './constants/breakpoints';

Vue.config.productionTip = false;

// Register the config independent modules.
Vue.use(vmodal);
Vue.use(vTooltip);
Vue.use(vMediaQuery);

// Disable tooltips on small screens (smartphones)
vTooltip.enabled = window.innerWidth > SCREEN_SM;

// Override the config with the one from /static/config
const configFileName = process.env.NODE_ENV === 'production' ? 'config.json' : process.env.NODE_ENV + '.json';
axiosInstance.get('/static/' + configFileName)
    .then(config => {
        Vue.prototype.$config = config;
        Vue.prototype.$config.debug = process.env.NODE_ENV === 'development';

        // Set the baseURL according to the latest config and register the instance.
        axiosInstance.defaults.baseURL = Vue.prototype.$config.api.url;
        Vue.use(VueAxios, axiosInstance);

        connectRaven();
        connectAnalytics();

        store.commit(SET_LANGUAGE, store.getters[GET_LANGUAGE]);

        new Vue({
            el: '#app',
            router,
            i18n,
            store,
            template: '<App/>',
            components: { App }
        });
    },
    err => console.log('No configuration fie provided.'));

// Error reporting configuration: Sentry + Raven
function connectRaven() {
    let config = Vue.prototype.$config;
    if (!config.debug && config.errorTracking && config.errorTracking.enabled) {
        Raven
            .config(config.errorTracking.url)
            .addPlugin(RavenVue, Vue)
            .install();
    }
}


function connectAnalytics() {
    // Connect analytics if enabled.
    let config = Vue.prototype.$config;
    if (!config.debug && config.analytics && config.analytics.enabled) {
        var VueAnalytics = require('vue-analytics');
        Vue.use(VueAnalytics, {
            id: config.analytics.id,
            router,
            autoTracking: {
                screenview: true,
                pageviewTemplate(route) {
                    return {
                        page: route.path,
                        title: route.name,
                        location: window.location.href
                    };
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/main.js